import { inject, Injectable } from "@angular/core";
import { NavigationExtras, Router, UrlTree } from "@angular/router";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { Web3MigrationRoutes } from "@modules/web3/w3st-migration.module";

@Injectable({ providedIn: "root" })
export class Web3NavigationService {
	private router: Router = inject(Router);
	private unviversalModalService = inject(UniversalModalService);

	gotoByPath(path: string): Promise<boolean> {
		return this.router.navigateByUrl(path);
	}

	createUrlTree(path: string): UrlTree {
		return this.router.createUrlTree([path]);
	}

	gotoWeb3ByUrl(path: Web3MigrationRoutes): Promise<boolean> {
		return this.router.navigate([{ outlets: { [ROUTER_OUTLET_NAME]: [Web3MigrationRoutes.basePath, path] } }]);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	gotoNavigate(path: any[], extras?: NavigationExtras): Promise<boolean> {
		return this.router.navigate([path], extras);
	}

	async closeModal(): Promise<void> {
		await this.unviversalModalService.close(ModalCloseReason.close);
	}
}
